import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"
import { Link } from "react-router-dom"

const NoAccessSection = () => {
  return (
    <div className="w-full h-screen flex justify-center items-center bg-gray-100">
      <div className="text-center">
        <ExclamationTriangleIcon className="h-16 w-16 text-red-500 mb-4 mx-auto" />
        <p className="font-poppins not-italic font-medium text-xl tracking-wide text-gray-800">
          Lab information not found! You may have to start the lab again.
        </p>
        <Link to="/all-lab-groups" className="mt-4 inline-block text-blue-500 underline text-lg">
          Go to Lab Groups
        </Link>
      </div>
    </div>
  )
}

export default NoAccessSection
